module.exports = "/matchcenter-staging/assets/images/match_timeline_iconsprite.04661f9c3ff6443b2a3a1b28059e765f.svg";